var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { getLocalStorageItem, LocalStorageKey, setLocalStorageItem, } from '@/shared/services/localStorageService';
import { ModalType, useModalContext } from '@/shared/providers/ModalProvider';
import { FaCog } from 'react-icons/fa';
import { getKpiMessage } from '@/modules/tasks/taskKpiMessages';
import { MyTasksWidgetKPIOptions } from '@/modules/tasks/taskboard/constants';
import messages from '../dashboardMessages';
import { MultipleTaskKpiTiles } from './tasks/MultipleTaskKpiTiles';
import AuthService from '@/shared/services/AuthService';
export var capacityPlanningOptions = [
    MyTasksWidgetKPIOptions.executionDateBeforeThisWeek,
    MyTasksWidgetKPIOptions.executionDateThisWeek,
    MyTasksWidgetKPIOptions.executionDateNextWeek,
    MyTasksWidgetKPIOptions.executionDateInTwoWeeks,
    MyTasksWidgetKPIOptions.executionDateInThreeWeeks,
];
var IsKpiVisibleByDefault = function (kipOptions) {
    if (kipOptions === MyTasksWidgetKPIOptions.pastDeadline ||
        kipOptions === MyTasksWidgetKPIOptions.deadlineOneWeek ||
        kipOptions === MyTasksWidgetKPIOptions.deadlineTwoWeeks ||
        kipOptions === MyTasksWidgetKPIOptions.deadlineThreeWeeks)
        return true;
    return false;
};
var MyTaskKpiDashboard = function () {
    var formatMessage = useIntl().formatMessage;
    var getInitialConfiguredKpis = function () {
        var kpiConfigurationsInStorage = getLocalStorageItem(LocalStorageKey.MyTasksWidgetConfiguredKpis, []);
        var hasCapacityPlanning = AuthService.hasFeature('CapacityPlanning');
        var kpiConfigurations = Object.values(MyTasksWidgetKPIOptions)
            .filter(function (x) { return hasCapacityPlanning || capacityPlanningOptions.indexOf(x) < 0; })
            .map(function (x) {
            var _a, _b;
            return ({
                id: x,
                label: formatMessage(getKpiMessage(x)),
                selected: (_b = (_a = kpiConfigurationsInStorage.find(function (y) { return y.id === x; })) === null || _a === void 0 ? void 0 : _a.selected) !== null && _b !== void 0 ? _b : IsKpiVisibleByDefault(x),
                individualClassName: x === MyTasksWidgetKPIOptions.nextUserIsMe ? 'margin15B' : '',
                zendeskArticle: x === MyTasksWidgetKPIOptions.nextUserIsMe ? '9580127747356' : '',
                title: x === MyTasksWidgetKPIOptions.pastDeadline
                    ? formatMessage(messages.KPIs)
                    : x === MyTasksWidgetKPIOptions.executionDateBeforeThisWeek
                        ? formatMessage(messages.ExecutionDates)
                        : null,
            });
        });
        return kpiConfigurations;
    };
    var _a = useState(getInitialConfiguredKpis()), kpiConfigurations = _a[0], setKpiConfigurations = _a[1];
    var setShowModalInfo = useModalContext().setShowModalInfo;
    var openKpiConfiguration = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setShowModalInfo({
                modalType: ModalType.CheckboxList,
                showSelectAll: false,
                title: formatMessage(messages.ConfigureKpis),
                checkboxListItems: kpiConfigurations,
                onSave: function (items) { return __awaiter(void 0, void 0, void 0, function () {
                    var storageItems;
                    return __generator(this, function (_a) {
                        storageItems = items.map(function (x) { return ({ id: x.id, selected: x.selected }); });
                        setLocalStorageItem(LocalStorageKey.MyTasksWidgetConfiguredKpis, storageItems);
                        setKpiConfigurations(items);
                        return [2 /*return*/];
                    });
                }); },
            });
            return [2 /*return*/];
        });
    }); };
    return (_jsxs("div", __assign({ className: "my-task-kpi-dashboard" }, { children: [_jsxs("div", __assign({ className: "title-block" }, { children: [formatMessage(messages.MyTasks), _jsx("span", __assign({ className: "pull-right " }, { children: _jsx("span", { children: _jsx(FaCog, { className: "react-icon", style: { marginTop: '2px' }, onClick: openKpiConfiguration }) }) }))] })), _jsx("div", __assign({ className: "content-block" }, { children: _jsx(MultipleTaskKpiTiles, { configuredKpis: kpiConfigurations.filter(function (x) { return x.selected; }).map(function (x) { return x.id; }) }) }))] })));
};
export default MyTaskKpiDashboard;
